
import React, { useState , useEffect , useContext} from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast, Zoom } from 'react-toastify';
import {  apibaseURl , updateSession , currencySymbol , errorToast , successToast , loggedInCustomerDetails  } from '../../../functions/Function';
import  { WebContext }  from "../../../Webroute";
const  Mobile = (props) => {
  const WebData = useContext(WebContext);
  const [otp, setOtp] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [inputs, setInputs] = useState({"user_id":206});
  const [validation, setValidation] = useState(null);
  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs(values => ({ ...values, [name]: value }))
  }

  const handleSendOTP = async (event) => {
    event.preventDefault();
    setDisabled(true);
    try {
      let res = await fetch(apibaseURl + "sendupdatemobileotp", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(inputs),
      });
      let output = await res.json();
      
      if (res.status === 200) {
        setDisabled(false);
        setValidation(null)
        if(output.result == true)
        {
          setOtp(true);
          successToast(output.response , 'bottom-right' , 3000  , true); 
        }else
        {
          if(output.validation == true)
          {
            setValidation(output.response)
          }else
          {
            errorToast(output.response , 'bottom-right' , 3000  , true);
          }
        }

      }
    } catch (err) {
      setDisabled(false);
    }
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    setDisabled(true);
    try {
      let res = await fetch(apibaseURl + "updateMobile", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(inputs),
      });
      let output = await res.json();
      
      if (res.status === 200) {
        setDisabled(false);
        setValidation(null)
        if(output.result == true)
        {
          successToast(output.response , 'bottom-right' , 3000  , true); 
          updateSession('phone' , inputs.mobile)
          WebData.updateUser();

          props.onHide();
        }else
        {
          if(output.validation == true)
          {
            setValidation(output.response)
          }else
          {
            errorToast(output.response , 'bottom-right' , 3000  , true);
          }
        }

      }
    } catch (err) {
      setDisabled(false);
    }
  }

  useEffect(() => {
    
    setOtp(false);
    setInputs({"user_id":loggedInCustomerDetails('id')});
 }, [props])
  return (
    <>
           <ToastContainer />
          <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
                Phone Number
            </Modal.Title>
          </Modal.Header>
              <Modal.Body>
              {otp == false &&
              <form method="POST" onSubmit={handleSendOTP}>
                  <div className="form-group mb-0">
                      <label>Mobile</label>
                      <div className="modal-input-foeld">
                            <input
                            type="text"
                            name="mobile"
                            value={inputs.mobile || ""}
                            onChange={handleChange}
                            placeholder="Enter Your Mobile"
                            className="form-control"
                          />
                          <div className="modal-btn">
                              <button className="btn ivo-site-btn ivo-site-btn-v-2" type="submit" disabled={disabled}> {disabled == false ? 'OTP' : 'Sending...'} </button>
                          </div>
                      </div>
                      {validation != null && validation.mobile != '' ?  <p className="erAlert text-danger  ">{validation.mobile}</p> : ''} 
                  </div>
                  <div className="mt-3 text-center">

                  </div>
              </form>
              }

            {otp == true &&
              <form method="POST" onSubmit={handleSubmit}>
                  <div className="form-group mb-0">
                      <label>OTP Code</label>
                      <div className="modal-input-foeld">
                            <input
                            type="text"
                            name="otp"
                            value={inputs.otp || ""}
                            onChange={handleChange}
                            placeholder="Enter Code Here"
                            className="form-control"
                          />
                          <div className="modal-btn">
                              <button className="btn ivo-site-btn ivo-site-btn-v-2" type="submit" disabled={disabled}> {disabled == false ? 'Update' : 'Updating...'} </button>
                          </div>
                      </div>
                      {validation != null && validation.otp != '' ?  <p className="erAlert text-danger  ">{validation.otp}</p> : ''} 
                  </div>
                  <div className="mt-3 text-center">

                  </div>
              </form>
              }
              </Modal.Body>
             
        </Modal>       
    </>

  );
}

export default Mobile;
